/* @generated from adl module ferovinum.sourcecontracts.common */

import * as ADL from './../../runtime/adl';

/**
 * Declares a published SQLMesh source contract (`source__<system>.<entity>`).
 * Applied to a flat struct whose fields ARE the published columns (the
 * already-flattened cleaned columns — a `@SourceContract` struct must be flat:
 * no union/struct/Vector/map field; those belong in db.adl where the cleaning
 * generator unpacks them). The `--source-contracts` generator emits one frozen
 * `source__<system>.<entity>.sql` per annotated struct: a thin
 * `SELECT [declared cols] FROM <generated_cleaned__>` carrying the model header.
 * FK references are NOT declared here — a field typed as a `DbKey<T>` alias
 * (e.g. `DealId = DbKey<Deal>`) carries its own target, which the generator
 * resolves into the model's `references(...)`. The annotation carries only what
 * cannot be a field type: the published model name, the grain, and the tags.
 */
export interface SourceContract {
  /**
   * The fully-qualified published model name, e.g. "source__app_db.deal_leg".
   */
  modelName: string;
  /**
   * The grain columns, e.g. ["id"].
   */
  grain: string[];
  /**
   * SQLMesh model tags, e.g. ["revenue", "source"].
   */
  tags: string[];
}

export function makeSourceContract(
  input: {
    modelName: string,
    grain: string[],
    tags: string[],
  }
): SourceContract {
  return {
    modelName: input.modelName,
    grain: input.grain,
    tags: input.tags,
  };
}

const SourceContract_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.common","decl":{"annotations":[{"value":"Declares a published SQLMesh source contract (`source__<system>.<entity>`).\n\nApplied to a flat struct whose fields ARE the published columns (the\nalready-flattened cleaned columns — a `@SourceContract` struct must be flat:\nno union/struct/Vector/map field; those belong in db.adl where the cleaning\ngenerator unpacks them). The `--source-contracts` generator emits one frozen\n`source__<system>.<entity>.sql` per annotated struct: a thin\n`SELECT [declared cols] FROM <generated_cleaned__>` carrying the model header.\n\nFK references are NOT declared here — a field typed as a `DbKey<T>` alias\n(e.g. `DealId = DbKey<Deal>`) carries its own target, which the generator\nresolves into the model's `references(...)`. The annotation carries only what\ncannot be a field type: the published model name, the grain, and the tags.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"The fully-qualified published model name, e.g. \"source__app_db.deal_leg\".\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"modelName","default":{"kind":"nothing"},"name":"modelName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The grain columns, e.g. [\"id\"].\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"grain","default":{"kind":"nothing"},"name":"grain","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"value":"SQLMesh model tags, e.g. [\"revenue\", \"source\"].\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"tags","default":{"kind":"nothing"},"name":"tags","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"SourceContract","version":{"kind":"nothing"}}};

export const snSourceContract: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.common", name:"SourceContract"};

export function texprSourceContract(): ADL.ATypeExpr<SourceContract> {
  return {value : {typeRef : {kind: "reference", value : snSourceContract}, parameters : []}};
}

/**
 * Columns available upstream that this contract DELIBERATELY does not publish.
 * Applied alongside `@SourceContract` on the same struct (remember the
 * `import ferovinum.sourcecontracts.common.UnpublishedColumns;`). An upstream column
 * (a generated_cleaned/compat output) that is neither a declared field nor
 * listed here fails the regen with `UnaccountedColumnError` — the developer
 * either publishes it (add a field) or records the omission here (a reviewed
 * contract decision, same as any other contract edit). An entry that names a
 * column no longer available upstream, or one that IS a declared field, fails
 * the build (StaleSuppressionError) — so the list always matches reality.
 */
export type UnpublishedColumns = string[];

const UnpublishedColumns_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.common","decl":{"annotations":[{"value":"Columns available upstream that this contract DELIBERATELY does not publish.\n\nApplied alongside `@SourceContract` on the same struct (remember the\n`import ferovinum.sourcecontracts.common.UnpublishedColumns;`). An upstream column\n(a generated_cleaned/compat output) that is neither a declared field nor\nlisted here fails the regen with `UnaccountedColumnError` — the developer\neither publishes it (add a field) or records the omission here (a reviewed\ncontract decision, same as any other contract edit). An entry that names a\ncolumn no longer available upstream, or one that IS a declared field, fails\nthe build (StaleSuppressionError) — so the list always matches reality.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}},"name":"UnpublishedColumns","version":{"kind":"nothing"}}};

export const snUnpublishedColumns: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.common", name:"UnpublishedColumns"};

export function texprUnpublishedColumns(): ADL.ATypeExpr<UnpublishedColumns> {
  return {value : {typeRef : {kind: "reference", value : snUnpublishedColumns}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.common.SourceContract" : SourceContract_AST,
  "ferovinum.sourcecontracts.common.UnpublishedColumns" : UnpublishedColumns_AST
};
